// Service Worker Registration pour OrderLab PWA
// Ce fichier gère l'enregistrement du service worker

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    // Attendre que la page soit complètement chargée
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // En localhost, vérifier que le SW existe
        checkValidServiceWorker(swUrl, config);
        
        navigator.serviceWorker.ready.then(() => {
          console.log(
            '🚀 OrderLab PWA: Service Worker actif en mode développement.'
          );
        });
      } else {
        // En production, enregistrer directement
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('✅ Service Worker enregistré:', registration);
      
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Nouveau contenu disponible
              console.log(
                '🔄 Nouveau contenu disponible. Rechargez pour mettre à jour.'
              );
              
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Contenu mis en cache pour offline
              console.log('📦 Contenu mis en cache pour utilisation offline.');
              
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('❌ Erreur enregistrement Service Worker:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Vérifier que le service worker existe
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Service worker introuvable, recharger la page
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker trouvé, procéder normalement
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('❌ Pas de connexion internet. App en mode offline.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Fonction pour vérifier si l'app peut être installée (PWA)
export function checkInstallPrompt() {
  let deferredPrompt;
  
  window.addEventListener('beforeinstallprompt', (e) => {
    // Empêcher le prompt automatique
    e.preventDefault();
    deferredPrompt = e;
    
    // Sauvegarder l'événement pour l'utiliser plus tard
    console.log('💾 PWA peut être installée');
    
    // Vous pouvez créer un bouton custom pour déclencher l'installation
    // Exemple dans votre UI:
    // const installButton = document.querySelector('#install-button');
    // installButton.style.display = 'block';
    // installButton.addEventListener('click', () => {
    //   deferredPrompt.prompt();
    //   deferredPrompt.userChoice.then((choiceResult) => {
    //     if (choiceResult.outcome === 'accepted') {
    //       console.log('✅ PWA installée');
    //     }
    //     deferredPrompt = null;
    //   });
    // });
  });
  
  // Détecter si l'app est déjà installée
  window.addEventListener('appinstalled', () => {
    console.log('✅ OrderLab PWA installée avec succès!');
    deferredPrompt = null;
  });
}
